import React from "react";
import { useDispatch } from "react-redux";
import ReCAPTCHA from "react-google-recaptcha";
import { loadCaptcha } from "../../../../../store/Concept/actions";

const Captcha = ({ detail }) => {
  const dispatch = useDispatch();

  const onChange = (value) => {
    dispatch(loadCaptcha(value));
  };

  if (detail) {
    return null;
  }

  return (
    <ReCAPTCHA
      sitekey="6LcuFU8gAAAAACC22ZdivH67kh43oYt7xaYnayq9"
      onChange={(e) => {
        onChange(e);
      }}
      action="new_payment"
    />
  );
};

export default Captcha;
